<template>
  <v-card class="px-2">
    <div class="d-flex align-center py-2">
      <span class="ml-1 font-19 font-weight-medium">Pedidos Pendentes</span>

      <v-divider vertical class="mx-4" />

      <Filtros ocultar_filtros_fixos @update:filtros="() => filtros.count_atualizar++">
        <template #prepend>
          <v-row class="mx-0 mt-2 pa-0">
            <v-col class="pa-0">
              <SysFilialGrupoAutocomplete
                v-model="filtros.filiais"
                label="Selecione as filias"
                :idsGrupo="filtros.grupos"
                multiple
                outlined
                :qtdeVisivelSelecionados="1"
                class="mb-n3"
              />
            </v-col>
          </v-row>

          <v-row class="mx-0 mt-2 pa-0">
            <v-col cols="6" class="pa-0">
              <SysSegmentoAutocomplete
                v-model="filtros.segmentos"
                label="Selecione os departamentos"
                multiple
                outlined
                :qtdeVisivelSelecionados="1"
                class="pr-1 mb-2"
              />
            </v-col>

            <v-col cols="6" class="pa-0">
              <SysCompradorAutocomplete
                v-model="filtros.compradores"
                label="Selecione os compradores"
                multiple
                outlined
                :qtde_visivel_selecionados="1"
                hide-details
                class="pl-1 mb-2"
              />
            </v-col>
          </v-row>

          <v-row class="mx-0 mt-2 pa-0">
            <v-col cols="6" class="pa-0">
              <SysFornecedorAutocomplete
                v-model="filtros.fornecedores"
                label="Selecione os fornecedores"
                :ids-segmento="filtros.segmentos"
                :ids-comprador="filtros.compradores"
                multiple
                outlined
                :qtdeVisivelSelecionados="1"
                class="pr-1 mt-2"
              />
            </v-col>

            <v-col cols="6" class="pa-0">
              <SysHistogramaPersonalizadoAutocomplete
                v-model="filtros.histogramas"
                :input_value="inputHistogramas"
                label="Selecione os histograma"
                return-object
                multiple
                outlined
                :qtdeVisivelSelecionados="1"
                class="pl-1 mt-2"
              />
            </v-col>
          </v-row>

          <DivisorComLegenda legenda="Flags" class="mb-4 mt-n3" />

          <div class="d-flex align-center">
            <v-switch
              v-model="filtros.apenas_pedidos_faturados"
              hide-details
              color="#a71830"
            >
              <template #label>
                <span class="pl-2">Apenas pedidos faturados</span>
              </template>
            </v-switch>
          </div>

          <div class="d-flex align-center mt-3" v-if="ocultarFlagApenasQtdePendenteMaiorQueZero === false">
            <v-switch
              v-model="filtros.apenas_qtde_pendente_maior_que_zero"
              hide-details
              color="#a71830"
            >
              <template #label>
                <span class="pl-2">Somente Pedidos pendentes</span>
              </template>
            </v-switch>
          </div>
        </template>
      </Filtros>

      <div class="w-400">
        <v-text-field
          class="ml-4"
          v-model="filtros.pesquisar"
          append-icon="mdi-magnify"
          label="Pesquisar"
          hide-details
          outlined
          dense
          :height="8"
          clearable
        />
      </div>

      <v-spacer />

      <ExportacaoParaExcel :filtros="filtros" />
    </div>

    <Tabela :filtros="filtros" />
  </v-card>
</template>

<script>
import Tabela from './Tabela.vue';
import Filtros from "@/components/Diagnostico/utils/Filtros";
import SysSegmentoAutocomplete from '@/components/utils/crud/SysSegmentoAutocomplete.vue';
import SysFornecedorAutocomplete from '@/components/utils/crud/SysFornecedorAutocomplete.vue';
import SysCompradorAutocomplete from '@/components/utils/crud/SysCompradorAutocomplete.vue';
import SysFilialGrupoAutocomplete from '@/components/utils/crud/SysFilialGrupoAutocomplete.vue';
import DivisorComLegenda from "@/components/utils/DivisorComLegenda";
import SysHistogramaPersonalizadoAutocomplete from '@/components/utils/crud/SysHistogramaPersonalizadoAutocomplete.vue';
import ExportacaoParaExcel from './ExportacaoParaExcel.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    Tabela,
    Filtros,
    SysFilialGrupoAutocomplete,
    SysSegmentoAutocomplete,
    SysFornecedorAutocomplete,
    SysCompradorAutocomplete,
    SysHistogramaPersonalizadoAutocomplete,
    ExportacaoParaExcel,
    DivisorComLegenda
  },
  data: () => ({
    inputHistogramas: [
      { id: 1, inicio: 0, fim: 30, descricao: 'Até 30 dias em aberto' },
      { id: 2, inicio: 31, fim: 60, descricao: 'De 31 a 60 dias em aberto' },
      { id: 3, inicio: 61, fim: 90, descricao: 'De 61 a 90 dias em aberto' },
      { id: 4, inicio: 90, fim: 0, descricao: 'Acima de 91 dias em aberto' },
    ],
    filtros: {
      id_unico_preferencia: 'ORDENACAO_TABELA_DASHBOARD_LISTA_PEDIDOS_PENDENTES',
      count_atualizar: 0,
      apenas_pedidos_faturados: false,
      apenas_qtde_pendente_maior_que_zero: true,
      pesquisar: null,
      grupos: [],
      filiais: [],
      segmentos: [],
      fornecedores: [],
      compradores: [],
      histogramas: []
    }
  }),
  mounted() {
    this.filtros.grupos = [this.COMPUTED_GRUPO_COMPRA];
  },
  computed: {
    ...mapGetters({
      COMPUTED_GRUPO_COMPRA: "usuario/getGrupoCompras",
    }),
    ocultarFlagApenasQtdePendenteMaiorQueZero () {
      return localStorage.ocultar_flag_apenas_qtde_pendente_maior_que_zero === 'S';
    }
  },
  watch: {
    COMPUTED_GRUPO_COMPRA(value) {
      this.filtros.grupos = [value];
    }
  }
}
</script>
